import { Tween } from "../../../../vendor_core/core/src/Tween";
import { FadeOut } from "../../../../vendor_core/core/src/transitions/TransitionAnimations";
import { DefaultLayers } from "../../../../vendor_core/core/src/utils/Layers";
import ViewManager from "../../../../vendor_core/core/src/utils/ViewManager";
import SpineAnimation from "../../../../vendor_core/core/src/views/SpineAnimation";



const backgroundLoop = () => {

    let scene = ViewManager.getLayer(DefaultLayers.Background).getCurrentScene();
    let anim = scene.spineAnimations.get("animation");
    anim.play("main_loop");
};

const backgrounBN1Start = () => {
    let scene = ViewManager.getLayer(DefaultLayers.Background).getCurrentScene();
    let anim = scene.spineAnimations.get("animation");
    return anim.play("BN1_start"); 
}

const backgrounBN1Loop = () => {
    let scene = ViewManager.getLayer(DefaultLayers.Background).getCurrentScene();
    let anim = scene.spineAnimations.get("animation");
    return anim.playAsync("BN1_loop");
}

const backgrounBN1Win = () => {
    let scene = ViewManager.getLayer(DefaultLayers.Background).getCurrentScene();
    let anim = scene.spineAnimations.get("animation");
    return anim.playAsync("BN1_loop_win");
}

const backgrounBN2Start = () => {
    let scene = ViewManager.getLayer(DefaultLayers.Background).getCurrentScene();
    let anim = scene.spineAnimations.get("animation");
    return anim.playAsync("BN2_start");
}

const backgrounBN2Loop = () => {
    let scene = ViewManager.getLayer(DefaultLayers.Background).getCurrentScene();
    let anim = scene.spineAnimations.get("animation");
    return anim.playAsync("BN2_loop");
}

const backgrounBN2Win = () => {
    let scene = ViewManager.getLayer(DefaultLayers.Background).getCurrentScene();
    let anim = scene.spineAnimations.get("animation");
    return anim.playAsync("BN2_loop_win");
}


const BackgroundHelper = {
    backgroundLoop,
    backgrounBN1Start,
    backgrounBN1Loop,
    backgrounBN1Win,
    backgrounBN2Start,
    backgrounBN2Loop,
    backgrounBN2Win
};

export default BackgroundHelper;